import { createRouter, createWebHistory } from "vue-router";
import MainView from "../views/MainView.vue";
import UnderConstructionView from "../views/UnderConstructionView.vue"; // Импортируйте компонент UnderConstruction

const routes = [
  {
    path: "/",
    name: "main",
    component: MainView,
  },
  {
    path: "/features",
    name: "features",
    component: () => import("../views/FeaturesView.vue"),
  },
  {
    path: "/underconstruction",
    name: "underconstruction",
    component: UnderConstructionView,
  },
  {
    path: "/about",
    name: "about",
    component: () => import("@/views/AboutUsView.vue"),
  },
  {
    path: "/contact",
    name: "contact",
    component: () => import("@/views/ContactsView.vue"),
  },
  {
    path: "/products",
    name: "products",
    component: () => import("@/views/ProductsView.vue"),
  },
  {
    path: "/products/yeram/registration",
    name: "yream_registration",
    component: () => import("@/views/YeramProjectRegistration.vue")
  },
  {
    path: "/:pathMatch(.*)*", // Catch-all route для всех неопределенных путей
    redirect: "/underconstruction",
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Если в URL есть хэш (например, #section1)
    if (to.hash) {
      return {
        el: to.hash, // Элемент, к которому нужно проскроллить
        behavior: "smooth", // Плавная прокрутка
      };
    }
    // Если есть сохраненная позиция (при возврате назад)
    if (savedPosition) {
      return savedPosition;
    }
    // По умолчанию скроллим в начало
    return { top: 0 };
  },
});

export default router;
